import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import { useAuth } from '~/auth/AuthProvider'

export const useMeterModels = (meterMakers: readonly string[], enabled = true): UseQueryResult<string[]> => {
  const { supabaseClient } = useAuth()
  return useQuery({
    queryKey: ['ops-meter-models', meterMakers],
    enabled: enabled && meterMakers.length > 0,
    queryFn: async (): Promise<string[]> => {
      const { data, error } = await supabaseClient
        .from('ops_meter_models')
        .select('meter_model')
        .in('meter_maker', [...meterMakers])
        .order('meter_model')
      if (error) throw error
      return [...new Set(data.map(({ meter_model }) => meter_model).filter((model): model is string => model !== null))]
    }
  })
}
